export const setActivePage = (state, payload) => {
    state.activePage = payload;
};

export const setLastUpdate = (state, payload) => {
    const existingModule = state.lastUpdate.find(obj => (payload.name === "diagrams" ? obj.processId === payload.processId : obj.name === payload.name));
    if (existingModule) {
        existingModule.date = payload.date;
    } else {
        state.lastUpdate.push(payload);
    }
};

export const setCurrentApplicationId = (state, payload) => {
    state.currentApplicationId = payload;
};

export const setFromAccountDisabled = (state, payload) => {
    state.fromAccountDisabled = payload;
};

export const setCurrentProcessId = (state, payload) => {
    state.currentProcessId = payload;
};

export const setInterfaceDirty = (state, payload) => {
    state.interfaceDirty = payload;
};
export const setTaskId = (state, payload) => {
    state.taskId = payload;
};

export const setSaveBtnVisible = (state, payload) => {
    state.showSaveIfPermission = payload;
};

export const setShowMultiLangOption = (state, payload) => {
    state.showMultiLangOption = payload;
};

export const setShowAccessibilityOption = (state, payload) => {
    state.showAccessibilityOption = payload;
};

export const setShowEnableAI = (state, payload) => {
    state.showEnableAI = payload;
};

export const setShowEnableTaskAI = (state, payload) => {
    state.showEnableTaskAI = payload;
};

export const setUserListDelegation = (state, payload) => {
    state.userListDelegation = payload;
};

export const setInfoApp = (state, payload) => {
    state.defaultInfoApp = payload;
};

export const setDisableOnLoad = (state, payload) => {
    state.disableOnLoad = payload;
};
export const setFromMyTeamsTasksMenu = (state, payload) => {
    state.fromMyTeamsTasksMenu = payload;
};
export const setIsOnLoadApplication = (state, payload) => {
    state.isOnLoadApplication = payload;
};
export const setNewProcessCreated = (state, payload) => {
    state.newProcessCreated = payload;
};
